module.exports = "/images/arrow-right.svg";